export function createProgressiveTranscriptManager(
  onUpdate: (
    lines: Array<{
      id: string
      speaker?: 'ai' | 'user'
      text?: string
      progressiveText?: string
      totalText?: string
      isComplete?: boolean
      isProgressive?: boolean
    }>
  ) => void
) {
  let state = {
    id: null as string | null,
    fullText: '',
    chunks: [] as string[],
    idx: 0,
    timer: 0 as any,
    active: false,
  }

  const start = (text: string, onTickDelay = 200) => {
    if (!text.trim()) return null
    const words = text.trim().split(/\s+/)
    const chunks: string[] = []
    for (let i = 0; i < words.length; i += Math.random() > 0.5 ? 2 : 3) {
      chunks.push(words.slice(i, i + (Math.random() > 0.5 ? 2 : 3)).join(' '))
    }
    const id = `ai-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
    state = {id, fullText: text.trim(), chunks, idx: 0, timer: 0, active: true}
    onUpdate([
      {
        id,
        speaker: 'ai',
        text: '',
        isProgressive: true,
        progressiveText: '',
        totalText: text.trim(),
        isComplete: false,
      },
    ])

    const step = () => {
      if (!state.active) return
      const progressive = state.chunks.slice(0, state.idx + 1).join(' ')
      onUpdate([
        {
          id: state.id!,
          progressiveText: progressive,
          text: progressive,
          isComplete: state.idx >= state.chunks.length - 1,
        },
      ])
      state.idx++
      if (state.idx < state.chunks.length) state.timer = setTimeout(step, onTickDelay)
      else state.active = false
    }

    state.timer = setTimeout(step, onTickDelay)
    return id
  }

  const stop = () => {
    if (state.timer) {
      clearTimeout(state.timer)
      state.timer = 0
    }
    if (state.active && state.id) onUpdate([{id: state.id, text: state.fullText, isComplete: true}])
    state.active = false
  }

  const pause = () => {
    if (state.timer) {
      clearTimeout(state.timer)
      state.timer = 0
    }
  }

  const resume = (delay = 100) => {
    if (!state.active || state.idx >= state.chunks.length) return
    const chunkDelay = Math.max(100, (state.fullText.length * 50) / state.chunks.length)
    const update = () => {
      if (!state.active || state.idx >= state.chunks.length) return
      const progressive = state.chunks.slice(0, state.idx + 1).join(' ')
      onUpdate([
        {
          id: state.id!,
          progressiveText: progressive,
          text: progressive,
          isComplete: state.idx >= state.chunks.length - 1,
        },
      ])
      state.idx++
      if (state.idx < state.chunks.length) state.timer = setTimeout(update, chunkDelay)
      else state.active = false
    }
    state.timer = setTimeout(update, delay)
  }

  return {start, stop, pause, resume}
}
